import { Children } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

// components
import ReferenceLink from '@aytm/app/stats/page/question-views/components/reference-link/ReferenceLink'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/BlockWrapper.module.scss'

// What every question block carries around whatever it draws: the link back to the question it
// stands for. The line that closes a question -- the count of how much it was answered, or what a
// block has to say in its place -- belongs to the question rather than to any one block, and is
// drawn once by QuestionFooter.
const BlockWrapper = ({ children, className, containerRef, id, link, answer, isSurveyGuest, isReportXpert }) => {
  return (
    <>
      {link && !isSurveyGuest ? (
        <ReferenceLink id={id} link={link} answer={answer} isReportXpert={isReportXpert} />
      ) : null}

      {0 < Children.toArray(children).length ? (
        <div ref={containerRef} className={classNames(style.container, className)}>
          {children}
        </div>
      ) : null}
    </>
  )
}

BlockWrapper.displayName = 'BlockWrapper'

BlockWrapper.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  // a block that reads its own drawn nodes back -- an export serializer, a measurement -- reaches
  // them through here rather than nesting a div of its own just to hold the ref
  containerRef: PropTypes.object,
  id: PropTypes.string,
  link: PropTypes.string,
  // the block's answer, whose comment count the reference link offers beside it
  answer: answerPropType,
  isSurveyGuest: PropTypes.bool,
  isReportXpert: PropTypes.bool
}

export default BlockWrapper
